export default "/_next/static/images/product--messenger-1e726476977846a1794da5bbf7a65bed.svg";